import React, { useEffect } from 'react';
import Heading2 from '../../components/Heading2';

declare global {
  interface Window {
    hbspt?: {
      forms: {
        create: (options: { region: string; portalId: string; formId: string; target: string }) => void;
      };
    };
  }
}

const NoSlotsAvailableView = () => {
  useEffect(() => {
    const loadHubSpotForm = () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: 'na1',
          portalId: '9176742',
          formId: '1ebd3d8b-a3dd-4724-8cb6-9144606e8d96',
          target: '#hubspot-concierge-form',
        });
      }
    };

    if (!document.querySelector('script[src="https://js.hsforms.net/forms/embed/v2.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/embed/v2.js';
      script.async = true;
      document.body.appendChild(script);

      script.addEventListener('load', loadHubSpotForm);

      return () => {
        script.removeEventListener('load', loadHubSpotForm);
        document.body.removeChild(script);
      };
    } else {
      loadHubSpotForm();
    }
  }, []);

  return (
    <div className="mb-6 max-w-[500px]">
      <Heading2>It Doesn't Look Like we Have Any Available Appointments</Heading2>
      <p className="text-gray-700 mb-6 text-center">
        It looks like we don't have any Skin Clique providers available on the selected date. You can select a different
        date or, if you fill out the form below, our concierge team will work with you to help you find a provider!
      </p>
      <div id="hubspot-concierge-form" className="hubspot-form hubspot-concierge-form"></div>
    </div>
  );
};

export default NoSlotsAvailableView;
